// frontend/src/hooks/useAnalytics.js
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { 
  trackPageView,
  trackEvent,
  trackCustomEvent,
  trackUserLogin,
  trackUserSignup,
  trackPurchase,
  trackExportDownload,
  trackCreditUsage,
  trackSearch,
  trackError,
  trackConversion,
  trackTiming,
  setUserId,
  setUserProperties
} from '../config/analytics';

// Custom hook to track page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);
};

// Custom hook to provide analytics functions
export const useAnalytics = () => {
  return {
    trackPageView,
    trackEvent,
    trackCustomEvent,
    trackUserLogin,
    trackUserSignup,
    trackPurchase,
    trackExportDownload,
    trackCreditUsage,
    trackSearch,
    trackError,
    trackConversion,
    trackTiming,
    setUserId,
    setUserProperties
  };
};

export default useAnalytics;